import BaseService from '@src/services/BaseService'

class QuestionnaireRecurrenceItemsService extends BaseService {
    constructor() {
        super('questionnaire-recurrence-items')
    }
}

export default new QuestionnaireRecurrenceItemsService()
